import script from "./phoneVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./phoneVideo.vue?vue&type=script&setup=true&lang=js"

import "./phoneVideo.vue?vue&type=style&index=0&id=08581028&lang=scss&scoped=true"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08581028"]])

export default __exports__